import { createContext, use, type ReactNode } from 'react';
import { useCopilotSession } from '@customerio/hydra-copilot/react';

type OnboardingCopilotSession = ReturnType<typeof useCopilotSession>;

const OnboardingCopilotSessionContext = createContext<OnboardingCopilotSession | null>(null);

export function useOnboardingCopilotSession() {
  const session = use(OnboardingCopilotSessionContext);
  if (session == null) {
    throw new Error('useOnboardingCopilotSession must be used within OnboardingCopilotSessionProvider');
  }
  return session;
}

type OnboardingCopilotSessionProviderProps = { children: ReactNode };

/**
 * A copilot session for the wizard, isolated from the app's primary one: no
 * `isPrimary` keeps it out of agent history and the `ai-session` URL sync, and
 * the `includeGlobal*` flags stop tools leaking either way. Register
 * wizard-scoped tools by passing this session to `useCopilotTool`.
 */
export function OnboardingCopilotSessionProvider({ children }: OnboardingCopilotSessionProviderProps) {
  const session = useCopilotSession({
    config: { includeGlobalTools: false, includeGlobalInstructions: false, includeGlobalContext: false },
  });

  return (
    <OnboardingCopilotSessionContext.Provider value={session}>{children}</OnboardingCopilotSessionContext.Provider>
  );
}
